/**
 * Shared bits for the My Wells screens. The wells themselves come from the API
 * now — this file used to carry a hard-coded copy of the list, which is exactly
 * the kind of thing that drifts away from the database without anyone noticing.
 */

/** Green while a well is active, red once it is abandoned or has no status. */
export function statusColor(status?: string) {
  return !status || status === 'Abandoning/Abandoned' ? '#c0392b' : '#2e9e4f';
}

/** "18/06/2026 00:08", the format the portal's Date Created column uses. */
export function formatCreated(iso?: string) {
  if (!iso) return '—';

  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';

  const pad = (n: number) => String(n).padStart(2, '0');
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(
    d.getMinutes(),
  )}`;
}
